<template>
  <div class="section-posts">
    <component-loader :progress="90" v-if="showLoader" :unlimitedProgress="true" :activeClose="true" v-on:close="showLoader = false"></component-loader>
    <div ref="loadableCalendar"
      class="calendar-wrapper table-wrapper scrollable calendar-table"
      :class="name+'-table'"
      v-if="pages"
    >
      <div class="select-week">
        <div class="previous" @click="changeWeek('previous')">
          <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
        </div>
        <component-datepicker
          class="posts-datepicker"
          v-on:picked="picked"
          :date="new Date(currentDate)"
          :noLimit="true"
          :eventOpen="openDatePicker"
        ></component-datepicker>
        <span @click="openDatePicker = !openDatePicker">{{ `${$t(`dash.planner.week`)} ${startDate.locale(this.$i18n.locale).format('LL')}` }}</span>
        <div class="next" @click="changeWeek('next')">
          <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
        </div>
      </div>

      <div class="calendar-content" ref="loadableCalendarContent">
        <div class="scrollable-x">
          <ul id="calendar-content-days" class="calendar-body head-days">
            <li class="column day" v-for="(day, key) in calendar" :key="key" :class="`day-${key}`"> 
              <ul class="calendar-head">
                <li class="column day-column">
                  <p :class="[{'past': checkPast(day.day, currentDate.hours()), 'current': checkCurrent(day.day)}]">
                    <span class="day">{{ $t(`dash.week.${formatDayEn(day.day, "dddd").toLowerCase()}`).substr(0, 3) }} {{ formatDate(day.day, "DD") }}</span>
                    <span class="posts">{{ nbPostsDay(key) }}</span>
                  </p>
                </li>
              </ul>
            </li>
          </ul>
          <ul id="calendar-content" class="calendar-body scrollable" @scroll="handleScroll">
            <li class="column day" v-for="(day, key) in calendar" :key="key" :class="`day-${key}`"> 
              <ul class="posts"> 
                <div v-for="(post, indexPost) in day.slots" :key="indexPost" class="post-cell">
                  <li :data-qa="`planner-post-${post.status}`" @click.stop.prevent="clickPost(post)" class="post" :class="[post.status, {'reshare': post.page && post.page[0] && post.page[0].is_reshare}, {'retweet': post.page && post.page[0] && post.page[0].is_retweet}, {'story': post.page && post.page[0] && post.page[0].story}]"> 
                    <!-- <div class="validated" v-if="post && post.page && post.page[0] && post.page[0].wait_validation && getWaitValidation(post)">
                      <Tooltip
                        :text="`${getWaitValidation(post).name} ${$t('dash.notification.validate_at')} ${dateFromNow(getWaitValidation(post).date)}`"
                        position="top"
                      >
                        <vs-avatar
                          color="transparent"
                          size="18px"
                          :src="
                            require('../../../assets/img/icon_check_light.svg')
                          "
                        />
                        &nbsp;
                      </Tooltip>
                    </div>
                    <div class="comments" v-if="post && post.page && post.page[0] && post.page[0].comments && post.page[0].comments.length">
                      <Tooltip
                        :text="`${post.page[0].comments.length} ${$t('dash.reporting.comments')}`"
                        position="top"
                      >
                        <span>{{ post.page[0].comments.length }}</span>
                        &nbsp;
                      </Tooltip>
                    </div> -->
                    
                    <div class="page-rs">
                      <Tooltip
                        :text="findPage(post._bots[0].page).name"
                        position="top"
                      >
                        <page-image-avatar :page="findPage(post._bots[0].page)"/>
                        &nbsp;
                      </Tooltip>
                    </div>
                    <Tooltip v-if="(post.status == 'preview' || post.status == 'slot' || post.status == 'failed' || post.status == 'inprogress')" :text="$t(getTooltip(post))" position="top">
                      <div class="content">
                        <div v-if="post.status != 'slot' && ((post._bots[0] && post._bots[0].mode === 'story' && post._bots[0].page && post._bots[0].page.story_config && post._bots[0].page.story_config.created) || (post._bots && post._bots.mode === 'story' && post._bots.page && post._bots.page.story_config && post._bots.page.story_config.created) )" class="story-img-planner">
                          <img :src="post.enclosure" alt="" @error="replaceByDefault">
                          <p>{{getText(post, true)}}</p>
                        </div>
                        <div v-else-if="post.status != 'slot' && post.enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.enclosure">
                        </div>
                        <span class="title" v-if="post.status != 'slot'">{{ getText(post) }}</span>
                        <span class="title" v-else>{{ $t(`dash.post.slot.empty`) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type">
                          <span>{{ getTypePost(post) }}</span>
                        </Tooltip>
                        <span class="state">{{ $t(`dash.post.${post.status}`) }}</span>
                      </div>
                    </Tooltip>
                    <template v-else-if="post.page && post.page[0] && post.page[0].is_reshare">
                      <div class="content">
                        <div v-if="post.enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.enclosure" @error="replaceByDefault">
                        </div>
                        <span class="title">{{ post.page[0].reshare_message }} - {{ getText(post) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type">
                          <span>{{ getTypePost(post) }}</span>
                          &nbsp;
                        </Tooltip>
                        <span class="state">{{ $t(`dash.post.reshare`) }}</span>
                      </div>
                    </template>
                    <template v-else-if="post.page && post.page[0] && post.page[0].is_retweet">
                      <div class="content">
                        <div v-if="post.enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.enclosure" @error="replaceByDefault">
                        </div>
                        <span class="title">{{ getText(post) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type">
                          <span>{{ getTypePost(post) }}</span>
                        </Tooltip>
                        <span class="state">{{ $t(`dash.posts.retweet`) }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="content">
                        <div v-if="post.enclosure" class="thumb-wrapper">
                          <img v-if="Array.isArray(post._bots)  && post._bots.length > 0 && post._bots[0].mode === 'story' && post.page && post.page[0] && post.page[0].story" class="story-screenshot-planner" :src="JSON.parse(post.page[0].story).screenshot" @error="replaceByDefault">
                          <img v-else-if="post._bots && post._bots.mode === 'story' && post.page && post.page[0] && post.page[0].story" class="story-screenshot-planner" :src="JSON.parse(post.page[0].story).screenshot" @error="replaceByDefault">
                          <img v-else class="thumb" :src="post.enclosure" @error="replaceByDefault">
                        </div>
                        <div v-else-if="post.page && post.page[0] && post.page[0].video" class="thumb-wrapper">
                          <video width="75" class="video-thumb" :src="post.page[0].video"></video>
                        </div>
                        <span class="title">{{ getText(post) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type">
                          <span>{{ getTypePost(post) }}</span>
                        </Tooltip>
                        <span class="state">{{ $t(`dash.post.${post.status}`) }}</span>
                      </div>
                    </template>
                  </li>
                </div>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <vs-popup class="sidebar-action" :title="``" :active.sync="showSidebar" v-if="showSidebar">
      <component-post-sidebar
        :gridData="gridData"
        :post="post"
        :sectionPlanner="true"
        :invite="true"
        v-on:addComment="addComment"
        v-on:validate="validatePost"
        v-on:openLoader="openLoader"
      ></component-post-sidebar>
    </vs-popup>
  </div>
</template>

<script>
import moment from 'moment'
import Posts from '../../mixins/Posts'
import User from '../../mixins/User'
import Insights from '../../mixins/Insights'
import Pages from '../../mixins/Pages'
import Bots from '../../mixins/Bots'
import Common from '../../mixins/Common'
import Groups from '../../mixins/Groups'
import componentDatepicker from '../Datepicker.vue'
import PageImageAvatar from '../PageImageAvatar.vue'
import componentLoader from '../overlay/Loader.vue'
import componentPostSidebar from '../PostSidebar.vue'
import ClickOutside from 'vue-click-outside'
import imgDefault from '../../../assets/img/no-picture.png'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
  name: 'component-shared-planner',

  components: {
    componentDatepicker, 
    PageImageAvatar,
    componentLoader,
    componentPostSidebar,
    Tooltip
  },

  mixins: [Common, Insights, User, Bots, Pages, Posts, Groups],

  directives: {
    ClickOutside
  },

  data() {
    return {
      key: null,

      currentDate: moment(),
      openDatePicker: false,
      startDate: null,
      endDate: null,

      pages: null,
      bots: null,
      posts: null,
      calendar: null,
      name: null,

      showLoader: false,
      showSidebar: false,
      post: {
        id: null,
        title: null,
        description: null,
        url: null,
        posted_date: null,
        scheduled_date: null,
        preview_date: null,
        date: null,
        status: null, // 0 preview - 1 scheduled - 2 posted - 3 inprogress
        page: null,
        pageObj: null,
        enclosure: null,
        stats: null,
        _bots: null
      },
    }
  },

  props: {
    
  },

 
  mounted() {
    let urlParams = new URLSearchParams(location.search)
    this.key = urlParams.get('key')
    this.initDaysWeekTab(moment())
    this.reloadDatas()
  },

  computed: {
    gridData() {
      return {
        pages: this.post.pageObj,
        posts: this.posts
      }
    },

  },

  methods: {

    async reloadDatas() {
      this.showLoader = true
      await this.getSharedPlanner(this.key, this.startDate, this.endDate)
      .then(res => {
        this.showLoader = false
        console.log('res', res)
        if(res.body && res.body.success){
          this.pages = res.body.pages
          this.bots = res.body.bots
          this.posts = res.body.posts
          this.calendar = res.body.calendar
          this.name = res.body.name
          this.$emit('nameAccount', this.name)
          this.$forceUpdate()
        }
      })
    },

    async addComment(post, message) {
      console.log('addComment', post)
      await this.addCommentPost(post, {
        name: this.name, 
        date: moment().format(),
        message})
      .then(() => {
        setTimeout(this.reloadDatas, 500)
      })
      .then(this.closeSidebar)
    },

    async validatePost(post) {
      console.log('validatePost', post)
      await this.validateWaitingPost(post, {
        name: this.name, 
        date: moment().format()
      })
      .then(() => {
        setTimeout(this.reloadDatas, 500)
      })
      .then(this.closeSidebar)
    },

    openLoader(bool){
      this.showLoader = bool
    },

    startOfWeek(date){
      let diff = moment(date).date() - moment(date).day() + (moment(date).day() === 0 ? -6 : 1)
      return moment(date).date(diff).hour(0).minute(0).second(0)
    },

    initDaysWeekTab(dateDebut) {
      return new Promise((resolve, reject) => {

        let date = this.startOfWeek(dateDebut)

        this.startDate = date
        this.endDate= moment(date).add(6, 'days').hour(23).minute(59).second(59)

        this.$emit('reload', date, this.endDate)

        resolve()
      })
    },

    /**
     * Date picked
     */
    picked(date) {
      this.openDatePicker = false
      this.initDaysWeekTab(date)
    },

    changeWeek(direction, inputDate=null) {
      let date
      if(direction == "previous"){
        date = moment(this.startDate).subtract(7, 'days')
      }
      else if(direction == "next") {
        date = moment(this.startDate).add(7, 'days')
      }
      else {
        date = inputDate
      }
      this.initDaysWeekTab(date)
      .then(async () => await this.reloadDatas())
    },

    formatDate(dateToFormat, format) {
      return moment(dateToFormat)
        .local()
        .format(format)
    },

    formatDayEn(dateToFormat, format) {
      return moment(dateToFormat)
        .locale('en')
        .format(format)
    },

    checkPast(day, hour) {
      let hourToCheck = moment(day).hour(hour)
      let currentHour = moment(this.currentDate).minute(0).second(0)
      return hourToCheck.isBefore(currentHour)
    },

    checkCurrent(day) {
      let currentDay = moment().utc().hour(0).minute(0).second(0)
      let isSameDay = moment(day).utc().format() == currentDay.format()
      return isSameDay
    },

    nbPostsDay(day){
      return this.calendar[day].slots.filter(post => post.status != 'slot').length
    },

    handleScroll() {
       const container = this.$el.querySelector("#calendar-content");
      const containerDays = this.$el.querySelector("#calendar-content-days");
      const containerHours = this.$el.querySelector("#calendar-content-hours");
      containerDays.scrollLeft = container.scrollLeft;
      containerHours.scrollTop = container.scrollTop;
    },

    /**
     * actions on click post
     * @param {Number} id - posts id to update
     */
    clickPost(post) {

      this.showSidebar = true

      this.post.id = post.id || null
      this.post._id = post.id || null
      this.post.title = post.title || null
      this.post.description = post.description || null
      this.post.url = post.url || null
      //this.post.enclosure = post.page && post.page[0] && post.page[0].enclosure ? post.page[0].enclosure : null
      this.post.posted_date = post.status == 'posted' ? post.page[0].posted_date : null
      this.post.scheduled_date = post.status == 'scheduled' || post.status == 'failed' ? post.page[0].scheduled_date : null
      this.post.preview_date = post.status == 'preview' ? post.preview_date : null
      this.post.date = post.status == 'slot' ? post.date : null
      this.post.status = post.status
      this.post.page = post.page || null   

      this.post._bots = post._bots || null
      this.post.pageObj = this.pages.find(p => post._bots[0].page == p.id)

      if(post.draft) {
        this.post.url = post.draft.data.form.file ? post.draft.data.form.file.url : (post.url || null)
        this.post.enclosure = post.enclosure
        this.post.title = this.getText(post)
        if(post.draft.data.form.documentTitle)
          this.post.page[0].document_title = post.draft.data.form.documentTitle

        // this.post.page = [{
        //   id:"62c447a0f6ce4853e854fee1",
        //   isDashboard:true,
        //   isManualPost:true,
        //   network:"twitter",
        //   post_number:"1588176949821726721",
        //   posted_date:"2022-11-03T14:31:06+00:00",
        //   status:6,
        //   utm:"",
        //   enclosure: post.enclosure

        // }]
      }


      //this.processInsights(post, this.page)
    },

    getTooltip(post) {
      switch(post.status) {
        case 'posted': return ''
        case 'scheduled': return ''
        case 'failed': return 'dash.post.failed.tooltip'
        case 'preview': return 'dash.scheduler.tooltip.preview'
        case 'slot': return 'dash.scheduler.tooltip.slot'
      }
    },

    getText(entry, title=false){

      let text = entry._bots && entry._bots.post_text_layout == 'description' ? entry.description : entry.title

      if(title) text = entry.title

      if(!text) text = ""

      if(entry.draft){
        //replace multi-mention
        while(text.includes('@[MENTIONS-')){
          let start = text.indexOf('@[MENTIONS-')
          let end = text.indexOf(']', start)
          let index = parseInt(text.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
          let mention = entry.draft.data.validMentions[index-1].find(m => m.network == entry._bots[0].type)
          if(mention && mention.value) 
            switch(mention.network){
              case 'twitter':
              case 'instagram':
                mention = mention.value.includes('@[') ? `@${mention.value.substring(2, mention.value.indexOf('('))}` : mention.value
                break
              case 'facebook':
              case 'linkedin':
                mention = mention.value.substring(2, mention.value.indexOf('('))
                break
              default:
          }
          else if(mention && mention.word){
            mention = mention.word
          }
          text = text.substr(0, start) + (mention ? mention : entry.draft.data.validMentions[index-1][0].word) + text.substr(end+1)
        }
      }

      //replace mention affected
      while(text.includes('@[')){
        let start = text.indexOf('@[')
        let end = text.indexOf(']', start)
        let mention = {
          network: entry._bots[0].type,
          value: text.substr(start, end-start+1)
        }
        if(mention) 
          switch(mention.network){
            case 'twitter':
            case 'instagram':
              mention = mention.value
              break
            case 'facebook':
            case 'linkedin':
              mention = `@${mention.value.substring(2, mention.value.indexOf('('))}`
              break
            default:
          }
        text = text.substr(0, start) + (mention ? mention : '') + text.substr(end+1)
      }
      
      return text
    },

    getDate(post){      
      let key = post.page ? Object.keys(post.page)[0] : null

      
      if(post.page && post.page[key] && post.page[key].posted_date) return this.formatDate(post.page[key].posted_date, 'HH:mm')     
      else if(post.page && post.page[key] && post.page[key].scheduled_date) return this.formatDate(post.page[key].scheduled_date, 'HH:mm')
      else if(post.preview_date) return this.formatDate(post.preview_date, 'HH:mm')
      else if(post.status == "slot") return this.formatDate(post.date, 'HH:mm')
    },

    getTypePost(post){
      if(post.page && post.page[0] && post.page[0].isScheduledPost)
        return 'A' //'P'
      if(post.page && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost))
        return 'M'
      return 'A'
    },

    getTypeTooltip(post){
      if(post.page && post.page[0] && post.page[0].isScheduledPost)
        return 'dash.post.type.scheduled'
      if(post.page && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost))
        return 'dash.post.type.manual'
      return 'dash.post.type.auto'
    },

    replaceByDefault(e) {
      e.target.src = imgDefault
    },

    closeSidebar() {
      this.showSidebar = false
    },

    dateFromNow(date){
      return moment(date).fromNow(0)    
    },

    getWaitValidation(post) {
      return post && post.page && post.page[0] ? JSON.parse(post.page[0].wait_validation) : null
    },

    findPage(id) {
      console.log('yooo',id)
      return this.pages.find(p => p.id == id)
    }
    
  },
  watch: {

  }
}
</script>
